import { Navigate } from 'react-router-dom';
import { useSessionStorage } from '../../../hooks';
import React, { useState, useEffect } from 'react';
import * as apiClient from "../../../common/apiClient";
import ReportViewer from '../../ui/reportViewer/reportviewer';
import {
  MainContainer
  , BoxContainer
  , Box
  , BoxLabel
  , SearchBox
  , Search
  , SearchImage,
  SearchInput,
  ScanContainer,
  ScanBox,
  Scan,
  ScanIcon,
  ScanDeviceRow,
  ScanDevice,
  CarHealthBad,
  DeviceId,
  Device,
  Content,
  ContentLabel,
  ContentValue,
  DownloadIcon,
  DownloadConatainer,
  BoxEmptyLabel

} from './styled';
import Search_Icon from '../../../assets/searchicon.svg';
import Car_Health_Bad from '../../../assets/carhealthbad.svg';
import Download from '../../../assets/download.png';

import {

  Spinner,
  SpinnerSize,

} from '../../../components';


export const AllScan = (props: any) => {
  const [authenticated, setAuthenticated] = useSessionStorage('authenticated');
  const [isLoadingActiveScan, setIsLoadingActiveScan] = useState(true);
  const [completedScan, setCompletedScan] = useState<any[]>([]);
  const [isOpenReport, setIsOpenReport] = useState<any>(false);
  const [isOpenLog, setIsOpenLog] = useState<any>(false);
  const [reportFiles, setReportFiles] = useState<any>([]);
  const [requestId, setRequestId] = useState<any>(null);

  useEffect(() => {
    loadCompletedScan(10, '-');
  }, []);
  const loadCompletedScan = (offset: any, searchtext: any) => {
    setCompletedScan([]);
    if (searchtext == "" || searchtext == null) {
      searchtext = "-";
    }
    apiClient.get(`requests/getCompleteScan/${localStorage.getItem("business_partner_id")}/${searchtext}/${offset}`, null).then((response: any) => {
      if (response) {
        setCompletedScan(response.activeScan);
      }
      setIsLoadingActiveScan(false);
    }).catch((err) => {
      setIsLoadingActiveScan(false);
    })
  };
  const formatDate = (isoString: any) => {
    let options: any = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };

    const date = new Date(isoString);
    return date.toLocaleString('en-US', options);
  }
  const handleClose = () => {
    setIsOpenReport(false);
  }
  const DownloadReport = (request_id: any) => {
    setRequestId(request_id);
    apiClient.get(`request-reports?filter[offset]=0&filter[limit]=100&filter[order]=id%20ASC&filter[where][requestId]=${request_id}`, null).then((response: any) => {
      if (response) {
        setIsOpenReport(true);
        setReportFiles(response);
        response.forEach((element: any) => {
          //downloadReport(element.reportUrl);
        });
      }

    }).catch((err) => {
    })
  };
  if (authenticated)
    return (
      <>

        {!isLoadingActiveScan &&
          <MainContainer>
            <BoxContainer>
              <Box>
                <BoxLabel>
                  All Scans
                </BoxLabel>
                <SearchBox>
                  <Search>
                    <SearchImage src={Search_Icon} />
                    <SearchInput type={"text"} placeholder='Search' onChange={(event) => loadCompletedScan(1000, event.target.value)} />
                  </Search>
                </SearchBox>
              </Box>
            </BoxContainer>
            <ScanContainer>
              {completedScan.map((item, index) => {
                return <ScanBox>
                  <Scan>
                    <ScanDeviceRow>
                      <ScanDevice>
                        <Device> Device</Device>
                        <DeviceId> {item.device_name}</DeviceId>
                      </ScanDevice>
                      <ScanIcon>
                        <CarHealthBad src={Car_Health_Bad} />
                      </ScanIcon>
                    </ScanDeviceRow>
                    <Content>
                      <ContentLabel>Car:</ContentLabel>
                      <ContentValue>{item.car_model}</ContentValue>
                    </Content>
                    <Content>
                      <ContentLabel>Date & Time:</ContentLabel>
                      <ContentValue>{formatDate(item.created_date)}</ContentValue>
                    </Content>
                    <Content>
                      <ContentLabel>Assignee</ContentLabel>
                      <ContentValue>{item.user_name}</ContentValue>
                    </Content>
                    <ScanDeviceRow>
                      <DownloadConatainer>
                        <DownloadIcon src={Download} onClick={() => DownloadReport(item.id)} />
                      </DownloadConatainer>
                    </ScanDeviceRow>
                  </Scan>
                </ScanBox>
              })}
            </ScanContainer>
            {isOpenReport && <ReportViewer requestId={requestId} close={handleClose} files={reportFiles} />}
          </MainContainer>

        }


      </>
    );
  return <Navigate to='/' replace />;

};
